import { z } from "zod";

export const SchemaEnvironment = z
  .object({
    REACT_APP_HOST: z.string(),
    REACT_APP_DATADOG_APPLICATION_ID: z.string(),
    REACT_APP_DATADOG_CLIENT_TOKEN: z.string().optional(),
    REACT_APP_BUCKET_BASEURL: z.string(),
    REACT_APP_APOLLO_URI: z.string(),
    REACT_APP_NAMESPACE: z.enum([
      "biz-tecma-prod",
      "biz-tecma-pre-prod",
      "biz-tecma-dev1",
      "biz-tecma-test",
      "biz-tecma-demo-prod",
    ]),
    REACT_APP_INFO_MAIL: z.string(),
    REACT_APP_REPORT_API_BASE_URL: z.string(),
    FEATURE_FLAG_CALENDAR: z.coerce.boolean(),
    REACT_APP_COOKIEBOT_ID: z.string().optional(),
    REACT_APP_CLARITY_ID: z.string().optional(),
    NODE_ENV: z.string(),
    REACT_APP_PRODUCT_CONFIGURATION_API_REST_URI: z.string(),
    REACT_APP_PROJECT_API_REST_URI: z.string(),
    REACT_APP_ROOM_SELECTOR_API_BASE_URL: z.string(),
    REACT_APP_ASSET_API_REST_URI: z.string(),
    REACT_APP_CLIENT_API_REST_URI: z.string(),
    REACT_APP_API_REST_BASE_URI: z.string(),
    REACT_APP_ERROR_API_ENDPOINT: z.string(),
    REACT_APP_WINSTON_LOG_LEVEL: z.string(),
    REACT_APP_PROJECT_API_BASE_URL: z.string(),
    REACT_APP_SPACE_API_BASE_URL: z.string(),
    REACT_APP_API_URI: z.string(),
    REACT_APP_PRODUCT_NAME: z.string(),
    REACT_APP_AWS_API_URI: z.string(),
    REACT_APP_AWS_TOKEN: z.string(),
    REACT_APP_TOKEN_EXPIRATION_THRESHOLD: z.string(),
  })
  .strict();
